import React from "react";
import moment from "moment";

const TradeCard = React.memo(({ item, isDollar }) => {
  // Logic to determine if this is a "Sauda" (Square off) entry
  const isSauda = item.type === "REMOVE" || item.type === "SQ.OFF";

  // Helper for currency symbol
  const currency = isDollar === 1 ? "$" : "₹";

  // Safe parsing helper
  const formatNum = (val, decimals = 2) => {
    const num = parseFloat(val);
    return isNaN(num) ? "0.00" : num.toFixed(decimals);
  };

  return (
    <div
      className="
        flex justify-between items-start py-2 px-0 
        border-b border-[var(--hover)] last:border-1
        transition-all duration-150
      "
    >
      {/* LEFT SIDE: Trade Details */}
      <div className="flex flex-col gap-1">
        {/* Symbol and Meta Row */}
        <div className="flex items-center gap-2">
          <span className="font-bold text-[15px] text-[var(--text)] uppercase">
            {item.symbol}
          </span>

          <span className="text-[10px] bg-[var(--hover)] px-1.5 py-0.5 rounded text-[var(--subtext)] font-bold">
            {item.script_type === "nse_cash"
              ? "EQUITY"
              : moment(item.expiry_date).format("DD MMM")}
          </span>

          <span
            className={`text-[11px] font-bold ${
              item.buy_sell === 0
                ? "text-[var(--buymeta)]"
                : "text-[var(--sellmeta)]"
            }`}
          >
            {item.buy_sell === 0 ? "BUY" : "SELL"} • {item.qty}
          </span>
        </div>

        {/* Price/Rate Section */}
        <div className="text-[13px] text-[var(--subtext)] flex items-center gap-1 font-medium">
          {isSauda ? (
            <>
              <span className="text-[var(--text)] font-semibold">
                {formatNum(item.standing_rate)}
              </span>
              {/* <span className="line-through opacity-60">{formatNum(item.standing_rate)}</span> */}
              <span className="text-[10px] px-1">→</span>
              <span className="text-[var(--text)] font-semibold">
                {formatNum(item.rate)}
              </span>
            </>
          ) : (
            <span className="text-[var(--text)]">{formatNum(item.rate)}</span>
          )}
        </div>

        {/* Timestamp */}
        <div className="text-[10px] text-[var(--subtext)]">
          {moment(item.date_created).format("DD-MM-YYYY | HH:mm:ss")}
        </div>
      </div>

      {/* RIGHT SIDE: Financials & Status */}
      <div className="text-right flex flex-col gap-1">
        {/* Commission/Brokerage */}
        <div className="text-[10px] text-[var(--subtext)] font-bold uppercase tracking-wider">
          COM: {formatNum(item.brokerage_user_amt)} {currency}
        </div>

        {/* P&L Amount */}
        <div
          className={`text-[16px] font-bold ${
            parseFloat(item.profit_loss) >= 0
              ? "text-[var(--buymeta)]"
              : "text-[var(--sellmeta)]"
          }`}
        >
          {parseFloat(item.profit_loss) > 0 ? "+" : ""}
          {formatNum(item.profit_loss)} {currency}
        </div>

        {/* Order Type Label */}
        <div
          className={`text-[10px] font-extrabold px-2 py-0.5 rounded-sm inline-block ml-auto ${
            isSauda
              ? "bg-red-500/10 text-[var(--sellmeta)]"
              : "bg-green-500/10 text-[var(--buymeta)]"
          }`}
        >
          {item.type}
        </div>

        {/* Additional Remarks */}
        {item.other && (
          <div className="text-[9px] font-semibold text-[var(--text)]">
            {item.other}
          </div>
        )}
      </div>
    </div>
  );
});

export default TradeCard;
